export default {
  description:
    'Lataa tarvitsemamme asiakirjat yrityksesi vahvistamista varten. Pakolliset asiakirjat on merkitty; valinnaiset voit lisätä nyt tai myöhemmin.',
  missing_one: 'Pakollinen asiakirja puuttuu vielä. Voit jatkaa: tämä vaihe pysyy avoinna, kunnes se on ladattu.',
  missing_other:
    '{{count}} pakollista asiakirjaa puuttuu vielä. Voit jatkaa: tämä vaihe pysyy avoinna, kunnes ne on ladattu.',
  buttons: {
    back: 'Takaisin',
    next: 'Seuraava',
    finish_later: 'Viimeistele myöhemmin',
  },
};
